// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Avatar, Card, DataListItem } from '@node-space/ui-components'

interface ContactCardProps {
  name: string
  showAvatar?: boolean
  title?: string
}

export const ContactCard = ({ name, showAvatar = true, title = '' }: ContactCardProps) => {
  const { t } = useTranslation()

  const titleText = title || t('contacts.addingToContact')

  return (
    <Card variant="static" emphasis full>
      <DataListItem
        size="large"
        layout="vertical"
        id="contact-card"
        title={titleText}
        BodyAvatar={showAvatar && <Avatar size="small" type="entity" name={name ?? ''} />}
        body={name}
      />
    </Card>
  )
}
